import { render, staticRenderFns } from "./PostJob.vue?vue&type=template&id=424a1366&"
import script from "./PostJob.vue?vue&type=script&lang=js&"
export * from "./PostJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports